import React from 'react';

import { PrimaryButton } from 'Components/Button';
import { ModalTrigger } from 'Components/Modal';
import { Card, CardBody } from 'Components/Card';

import RemoteControlConnect from './Modals/RemoteControlConnect';

import { translation } from 'Services/TranslationHelpers';

export default class RemoteControl extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <React.Fragment>
                {window.base.main_stage.layout === 'default' && this.renderButton()}

                {window.base.main_stage.layout === 'tabs' && (
                    <Card className={`h-full bg-app-gray text-app-blue rounded-b-xl`} bgColour="bg-app-blue" titleColor="text-white">
                        <CardBody className="h-full flex flex-col">
                            <h1 className="text-2xl font-bold text-app-blue" ref={ref => this.titleRef = ref}>
                                {translation('main_stage_frontend', 'launch_remote_control')}
                            </h1>

                            <div className="flex justify-center items-center h-full">
                                {this.renderButton()}
                            </div>
                        </CardBody>
                    </Card>
                )}
            </React.Fragment>
        );
    }

    /**
     * @method renderButton
     * @return {JSX.Element}
     */
    renderButton = () => (
        <ModalTrigger
            component={RemoteControlConnect}
            props={{
                sessionId: this.props.sessionId,
            }}
        >
            <PrimaryButton
                text={translation('main_stage_frontend', 'launch_remote_control')}
            />
        </ModalTrigger>
    );
}
